import React, { useEffect, useState, useContext } from "react"

import { Formik, Form } from "formik"
import {Check, DatePicker, Input} from "components/anti/forms/forms"
import { Button } from "components/anti/buttons/buttons"
import { gql, useMutation } from "@apollo/client"
import { Modal } from "components/anti/modal/modal"
import OtpInput from "react-otp-input"
import * as Yup from "yup"
import { useScrollAnim } from "src/components/hooks/hooks"

import { submitUtm, extractCookie } from "../../../../../utils/handle-utm"
import {Checkbox} from "@material-ui/core";
import {FormCheck} from "react-bootstrap";

export const ProjectDetailsLeadForm = ({
	lang,
	cpi,
	title,
	utmId,
	slug,
	city,
	propertyType,
	datalayerAdd,
}) => {
	const [trigger, anim] = useScrollAnim()

	const phoneRegex = /^(^\+62\s?|^0)(\d{3,4}-?){2}\d{3,4}$/

	// OTP States
	const [otpServer, setOtpServer] = useState('secret')
	const [OtpModal, setOtpModal] = useState("")
	const [timeLimit, setTimeLimit] = useState(30)
	const [otpError, setOtpError] = useState(false)
	const [sentSuccess, setSentSuccess] = useState(false)
	const [btnDisabled, setBtnDisabled] = useState(true)
	const [isChecked, setIsChecked] = useState(false)


	const [contactUsForm, setContactUsForm] = useState({
		name: "",
		email: "",
		otpCode: "",
		phoneNumber: "+62",
		visitDate: "",
		tnc: "true",
		clientMutationId: "secret"
	})

	const initialRegisterValues = {
		name: "",
		email: "",
		otpCode: "",
		visitDate: "",
		phoneNumber: "+62",
		tnc: "true",
		clientMutationId: "secret"
	}

	const [requestOtp] = useMutation(GET_MORE_INFO.REQUEST_OTP)
	const [submitFormGetMoreInfo] = useMutation(GET_MORE_INFO.SUBMIT_OTP)

	const YupRegisterValidation = Yup.object({
		email: Yup.string().email(lang === "en" ? "Invalid email format" : "Format email salah").required(lang === "en" ? "Email Required" : "Masukkan email anda"),
		name: Yup.string().required(lang === "en" ? "Name required" : "Masukkan nama anda"),
		phoneNumber: Yup.string()
			.required(lang === "en" ? "Mobile Number required" : "Masukkan nomor handphone anda")
			.matches(phoneRegex, lang === "en" ? "Invalid Mobile Number" : "Format yang anda masukkan salah"),
	})

	const requestOTPHandler = (values, { resetForm }) => {
		setOtpModal("otp-modal")
		setTimeLimit(30)

		setContactUsForm({ ...contactUsForm, ...values })
		const phoneNumber = values.phoneNumber.slice(1)
		let requestOTPForm = { phoneNumber, clientMutationId: "" }
		resetForm()
		requestOtp({ variables: requestOTPForm })
			.then(({ data }) => {
				if (data.requestOtp.status !== "error") {
					let getOTP = data.requestOtp.message.split('Your OTP: ')[1].slice(0, 6)
					// console.log('YOUR OTP CODE:', getOTP)
					setOtpServer(getOTP)
				}
			})
			.catch(err => {
				console.log('failed to request OTP:', err)
			})
	}

	const resendOtp = () => {
		const phoneNumber = contactUsForm.phoneNumber.slice(1)
		setTimeLimit(30)

		let requestOTPForm = { phoneNumber, clientMutationId: "" }
		requestOtp({ variables: requestOTPForm })
			.then(({ data }) => {
				if (data.requestOtp.status !== "error") {
					let getOTP = data.requestOtp.message.split('Your OTP: ')[1].slice(0, 6)
					// console.log('YOUR OTP CODE:', getOTP)
					setOtpServer(getOTP)
					// return data.requestOtp
				}
				// return false
			})
			.catch(err => {
				console.log('failed to request OTP:', err)
			})

	}

	const submitForm = () => {
		if (otpServer !== contactUsForm.otpCode) {
			setOtpError(true)
			setContactUsForm({ ...contactUsForm, otpCode: "" })
		} else {
			const phoneNumber = contactUsForm.phoneNumber.slice(1)
			const urlPOST = process.env.GATSBY_CPI_URL
			submitFormGetMoreInfo({ variables: { ...contactUsForm, phoneNumber } })
				.then(({ data }) => {
					// console.log(data)
					datalayerSubmit()
				})
				.catch(err => {
					console.log(err)
				})
				.finally(() => {
					datalayerSuccess()
					setOtpError(false)
					setSentSuccess(true)
					setOtpModal("success-modal")
					setOtpServer('secret')
					setContactUsForm({
						name: "",
						email: "",
						otpCode: "",
						visitDate: "",
						phoneNumber: "+62",
						tnc: "true",
						clientMutationId: ""
					})

					const sendData = {
						"fullname": contactUsForm.name,
						"email": contactUsForm.email,
						"mobile": contactUsForm.phoneNumber,
						"visit_date": contactUsForm.visitDate,
						"tnc": contactUsForm.tnc,
						"project_name": title,
						"projects_code": cpi?.projectCode,
						"cluster_code": cpi?.clusterCode,
						"lead_source_name": cpi?.leadSourceName,
						"web": "dutapertiwi.com",
					}

					submitUtm(sendData)

					// fetch(urlPOST, {
					// 	method: "POST",
					// 	headers: {
					// 		'Content-Type': 'application/json',
					// 		"Access-Control-Allow-Headers": "Content-Type",
					// 		"Access-Control-Allow-Origin": "https://diamond-lk99.antikode.dev",
					// 		"Access-Control-Allow-Methods": "OPTIONS,POST,GET"
					// 	},
					// 	body: JSON.stringify(sendData)
					// }).then(data => {
					// 	console.log("fetch res", data)
					// }).catch(err => console.log(err))
				})
		}
	}

	const datalayerSubmit = () => {
		const value = {
			'event': 'InitiateCheckout',
			'page_url': window.location.href, // entire string of current page URL including UTM parameter and hash # if any
			'page_title': title,
			'content_type': 'home_listing',
			'content_id': slug, // any IDs in your listing catalog, example: 'Provence Suites'
			'city': city, // provide the user's city of the interest, example 'BSD City'
			'region': city, // state, district, or region of interest, example 'South Tangerang'
			'country': 'Indonesia', // target country of the interest, example 'Indonesia'
			'lease_start_date': datalayerAdd?.leaseStartDate,
			'lease_end_date': datalayerAdd?.leaseEndDate,
			'currency': 'IDR',
			'preferred_price_range': datalayerAdd?.preferredPriceRange, // provide in floating data type [500000000.00, 1000000000.00]
			'preferred_baths_range': datalayerAdd?.preferredBathsRange, // provide in integer data type: [1, 2] 'preferred_bed_range': 'bed range', // provide in integer data type: [2, 3]
			'property_type': propertyType // example value: 'apartment' or 'condo' or 'house' or 'land' or 'manufactured' or 'other' or' townhouse'

		}

		window.dataLayer = window.dataLayer || []
		window.dataLayer.push(value)
	}

	const datalayerSuccess = () => {
		const value = {
			'event': 'Purchase',
			'page_url': window.location.href, // entire string of current page URL including UTM parameter and hash # if any
			'page_title': title,
			'content_type': 'home_listing',
			'content_id': slug, // any IDs in your listing catalog, example: 'Provence Suites'
			'city': city, // provide the user's city of the interest, example 'BSD City'
			'region': city, // state, district, or region of interest, example 'South Tangerang'
			'country': 'Indonesia', // target country of the interest, example 'Indonesia'
			'lease_start_date': datalayerAdd?.leaseStartDate,
			'lease_end_date': datalayerAdd?.leaseEndDate,
			'currency': 'IDR',
			'preferred_price_range': datalayerAdd?.preferredPriceRange, // provide in floating data type [500000000.00, 1000000000.00]
			'preferred_baths_range': datalayerAdd?.preferredBathsRange, // provide in integer data type: [1, 2]
			'preferred_bed_range': datalayerAdd?.preferredBedRange, // provide in integer data type: [2, 3]
			'property_type': propertyType // example value: 'apartment' or 'condo' or 'house' or 'land' or 'manufactured' or 'other' or' townhouse'
		};

		window.dataLayer = window.dataLayer || []
		window.dataLayer.push(value)
	}

	useEffect(() => {
		if (timeLimit > 0 && OtpModal) {
			setTimeout(() => {
				setTimeLimit(timeLimit - 1)
			}, 1000)
		}
	}, [timeLimit, OtpModal])


	useEffect(() => {
		if (contactUsForm.otpCode.length >= 6) {
			submitForm()
		}
	}, [contactUsForm.otpCode])


	return (
		<section className="py-main sc-projectDetails-leadForm" ref={trigger}>
			<div className="container">
				<h2 className={`${anim(1)}`}>{lang === "en" ? "Get More Information" : "Informasi Lebih Lanjut"}</h2>
				<Formik
					initialValues={initialRegisterValues}
					validationSchema={YupRegisterValidation}
					onSubmit={requestOTPHandler}
				>
					{({ handleChange,
						errors,
						touched,
						values,
					}) => (
						<Form target="_blank">
							<div className="form-row row-4">
								<div className="form-group col-md-3">
									<Input
										floatingLabel
										variant={"underline"}
										label={lang === "en" ? "Name" : "Nama"}
										// inputClassName={inputClassName}
										as="input"
										id="name"
										name="name"
										value={values["name"]}
										onChange={handleChange}
										touched={touched}
										errors={errors}
										className={`${anim(2)}`}
									// value={contactUsForm.name}
									// onChange={e => setContactUsForm({ ...contactUsForm, name: e.target.value })}
									// errors={error}
									/>
								</div>
								<div className="form-group col-md-3">
									<Input
										floatingLabel
										variant={"underline"}
										label={"Email"}
										// inputClassName={inputClassName}
										as="input"
										type="email"
										id="email"
										name="email"
										value={values["email"]}
										onChange={handleChange}
										touched={touched}
										errors={errors}
										className={`${anim(3)}`}
									// value={contactUsForm.email}
									// onChange={e => setContactUsForm({ ...contactUsForm, email: e.target.value })}
									// onChange={handleChange}
									// errors={error}
									/>
								</div>
								<div className="form-group col-md-3">
									<Input
										floatingLabel
										variant={"underline"}
										label={lang === "en" ? "Mobile Number" : "Nomor Handphone"}
										// inputClassName={inputClassName}
										as="input"
										id="phoneNumber"
										name="phoneNumber"
										value={values["phoneNumber"]}
										onChange={handleChange}
										touched={touched}
										errors={errors}
										className={`${anim(4)}`}
									// value={contactUsForm.phoneNumber}
									// onChange={e => setContactUsForm({ ...contactUsForm, phoneNumber: e.target.value * 1 ? e.target.value : '' })}
									// onChange={handleChange}
									// errors={error}
									/>
								</div>
								<div className="form-group col-md-3">
									<DatePicker
										floatingLabel
										variant={"underline"}
										value={values["visitDate"]}
										label={lang === "en" ? "Visit Date" : "Tanggal Visit"}
										name="visitDate"
										id="visitDate"
										onChange={handleChange}
										touched={touched}
										errors={errors}
										className={`${anim(4)}`}
									/>
								</div>
							</div>
							<div className="form-row mt-4">
								<div className="form-group col-md-10 mx-auto text-center">
									<Check
										id="tnc"
										checked={isChecked}
										onChange={() => setIsChecked(!isChecked)}
									>
										<span>I aggree to the <a href="https://dutapertiwi.com/terms-conditions/">terms and conditions</a> that apply.*</span>
									</Check>
								</div>
							</div>
							<div className="form-row text-center">
								<div className="form-group col-md-3 mx-auto">
									<Button
										variant="primary"
										className={`btn-block text-uppercase ${anim(5)}`}
										type="submit"
										disabled={sentSuccess || !isChecked}
									>
										{sentSuccess ? (
											lang === "en" ? "Sent ✓" : "Terkirim ✓"
										) : (
											"Submit"
										)}
									</Button>
									{/* <Button
										variant="link"
										onClick={() => setOtpModal("success-modal")}
									>
										test modal
									</Button> */}
								</div>
							</div>
						</Form>
					)}
				</Formik>
			</div>
			{OtpModal &&
				<>
					<Modal
						id="otp-modal"
						isShowing={OtpModal}
						hide={() => setOtpModal("")}
						title={lang === "en" ? `OTP Verification` : "Verifikasi OTP"}
						titleClassName="text-center"
						text={lang === "en" ? "To proceed, please enter the 6-digit OTP code sent to your mobile number" : "Untuk melanjutkan, masukkan 6 digit kode OTP yang dikirimkan ke nomor ponsel Anda"}
						textClassName="text-center"
					>
						<p className="text-center font-weight-bold">{contactUsForm.phoneNumber}</p>
						<OtpInput
							value={contactUsForm.otpCode}
							containerStyle="otp-container"
							inputStyle={`otp-input`}
							onChange={val => setContactUsForm({ ...contactUsForm, otpCode: val })}
							numInputs={6}
							isInputNum={true}
							hasErrored={true}
						/>
						{otpError && (
							<p className="text-danger text-center mt-2">{lang === "en" ? "Invalid OTP code. Try again." : "Kode TOP salah, coba lagi."}</p>
						)}
						<p className="text-muted text-center pt-3 mb-0">{lang === "en" ? "Haven't received OTP code?" : "Belum mendapatkan kode OTP?"}</p>
						<Button className={`text-center pt-0 ${timeLimit > 0 ? "text-muted" : "font-weight-bold"}`} type="button" onClick={resendOtp} disabled={timeLimit > 0}>
							{timeLimit > 0 ? `${lang === "en" ? "Resend" : "Kirim Ulang"} (${timeLimit})` : `${lang === "en" ? "Resend" : "Kirim Ulang"}`}
						</Button>

					</Modal>
					<Modal
						id="success-modal"
						isShowing={OtpModal}
						hide={() => setOtpModal("")}
						className="success-modal"
					>
						<div className="container">
							<h2 className="mt-5">Thank You!</h2>
							<p>
								Terima kasih telah tertarik dengan program kami. Anda akan dihubungi
								oleh tim kami untuk program yang ditawarkan
							</p>
						</div>
					</Modal>
				</>
			}
		</section >
	)
}

const GET_MORE_INFO = {
	REQUEST_OTP: gql`
	mutation REQUEST_OTP($phoneNumber: String!) {
		requestOtp(input: {phoneNumber: $phoneNumber, clientMutationId: ""}) {
			status
			message
			clientMutationId
		}
	}`,
	SUBMIT_OTP: gql`
	mutation SUBMIT_GET_MORE_INFO($name: String!, $email: String!, $otpCode: String!, $phoneNumber: String!, $visitDate: String!, $tnc: String!, $clientMutationId: String!) {
		submitFormGetMoreInfo(input: {name: $name, email: $email, otpCode: $otpCode, phoneNumber: $phoneNumber, visitDate: $visitDate, tnc: $tnc, clientMutationId: $clientMutationId}) {
			status
			message
			clientMutationId
		}
	}
	`,
}